import React from 'react'

export const educationOptions = [
  'High School',
  "Bachelor's Degree",
  "Master's Degree"
]

export const experienceOptions = [
  { value: 'Student', label: 'Student' },
  { value: 'Less than 1', label: 'Less than 1 year' },
  { value: '1-2', label: '1-2 years' },
  { value: '3-5', label: '3-5 years' },
  { value: '6-9', label: '6-9 years' },
  { value: '10+', label: '10 or more years' }
]

export const ugMajors = [
  'Accounting',
  'Actuarial Science',
  'Business',
  'Economics',
  'Finance',
  'Hotel Administration',
  'Management',
  'Marketing',
  'Other Business/ Management/  Economics',
  'Computer science',
  'Engineering',
  'Information systems/technology',
  'Operations management/production',
  'Other engineering/computer science',
  'Architecture',
  'Fine arts',
  'Other fine arts',
  'Art history',
  'English',
  'History',
  'Journalism',
  'Languages',
  'Philosophy',
  'Other humanities',
  'Agriculture',
  'Biological sciences',
  'Chemistry',
  'Mathematics',
  'Medicine/nursing',
  'Physics',
  'Statistics',
  'Other science/mathematics',
  'Anthropology',
  'Education',
  'Government',
  'Law',
  'Political sciences',
  'Psychology',
  'Sociology',
  'Other social sciences/law'
]

export const careerPathQuestions = [
  <>
    <p className='g--font-h4'>Select the next job you want</p>
    <p>
      Either pick one of the following or scroll down and search for the job you
      want
    </p>
  </>,
  <>
    <p className='g--font-h4'>Select the job you want in 5 years time</p>
    <p>
      Either pick one of the following or scroll down and search for the job you
      want
    </p>
  </>
]
export const careerPathQuestionsStudent = [
  <>
    <p className='g--font-h4'>Select the job you want after graduating</p>
    <p>
      Either pick one of the following or scroll down and search for the job you
      want
    </p>
  </>,
  <>
    <p className='g--font-h4'>Select the job you want in 5 years time</p>
    <p>
      Either pick one of the following or scroll down and search for the job you
      want
    </p>
  </>
]

export const careerPathLabels = [
  'Your next role will be a...',
  'In 5 years time you’ll be a...'
]

export const careerGoalRoles = [
  'Chief Executive Officer',
  'Chief Financial Officer',
  'Chief Information Officer',
  'Chief Marketing Officer'
]

export const studentRole = {
  salary: 38000,
  nextRoles: [
    'Business Analyst (General)',
    'Marketing Associate',
    'Software Developer / Engineer',
    'Account Executive (General)',
    'Financial Analyst (General)',
    'Project Coordinator',
    'Office / Administrative Assistant'
  ]
}

export const skillGroups = {
  Essential: (
    <>
      These are the <b>essential skills</b> that are required for any role in
      this field.
    </>
  ),
  Specialist: (
    <>
      The following <b>professional skills</b> are specific to the role you
      want.
    </>
  ),
  Distinguishing: (
    <>
      Standout candidates typically have one or more of these{' '}
      <b>distinguishing skills.</b>
    </>
  )
}

export const graduationOptions = ['2020', '2021', '2022']
